// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
        ? self
        : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
            ? global
            : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"2dydu":[function(require,module,exports,__globalThis) {
require("6041c641a5f3323").register(require("92548d1100badfdf").getBundleURL('kkkhJ'), JSON.parse("[\"kkkhJ\",\"index.91397171.js\",\"5vcKv\",\"atlassian-light.39e1549b.js\",\"6o6gJ\",\"atlassian-light-future.bd6bed96.js\",\"hBOIv\",\"atlassian-light-finesse.daf0e4cf.js\",\"ifnSN\",\"atlassian-light-increased-contrast-finesse.fd3e0456.js\",\"29n0N\",\"atlassian-light-increased-contrast.1757fa1b.js\",\"g83mS\",\"UNSAFE-dynamic.2eb5fe73.js\",\"gScge\",\"UNSAFE-dynamic-dark.2d163a62.js\",\"dpeLC\",\"UNSAFE-test-light.db13d0ae.js\",\"3qFXy\",\"UNSAFE-test-dark.afc5f5ad.js\",\"7MiB3\",\"atlassian-dark.2ca6f383.js\",\"9kzPW\",\"atlassian-dark-future.9acdcfc7.js\",\"l9F2A\",\"atlassian-dark-finesse.e270ab78.js\",\"atKux\",\"atlassian-dark-increased-contrast-finesse.b6fc98bd.js\",\"7BlKt\",\"atlassian-dark-increased-contrast.6dc2dbd2.js\",\"auqcp\",\"atlassian-spacing.83ae85be.js\",\"1wUNB\",\"atlassian-typography.bc61811f.js\",\"lkR9M\",\"UNSAFE-typography.3bfa825f.js\",\"dpX25\",\"atlassian-typography-finesse.a6b00997.js\",\"l51TO\",\"atlassian-shape.752d0ac1.js\",\"bZZmZ\",\"atlassian-motion.e303ebe9.js\",\"kctVh\",\"custom-theme.b431ea61.js\",\"MPOnK\",\"cs.ea29ee44.js\",\"gVDfT\",\"da.7ea750d6.js\",\"dIrro\",\"de.2b43b155.js\",\"6KHZa\",\"en_GB.9c8f74ec.js\",\"aB9xC\",\"en_ZZ.ca9a9bd6.js\",\"byFnW\",\"es.dbbc5660.js\",\"aM5FL\",\"fi.612306fc.js\",\"lPVP4\",\"fr.fddd428a.js\",\"4E3Up\",\"hu.d218c70f.js\",\"31T3F\",\"it.1334e07b.js\",\"kU8UN\",\"ja.369c2c44.js\",\"jUKrZ\",\"ko.6c1cf4d2.js\",\"2P4VV\",\"nb.bf9bef67.js\",\"fQjeh\",\"nl.d069d205.js\",\"5ytOl\",\"pl.a9c7b20c.js\",\"2kbmC\",\"pt_BR.e56976f8.js\",\"aXMdp\",\"ru.8024a564.js\",\"cOHLf\",\"sl.56a32974.js\",\"dYz4o\",\"sr_RS.b4f4780c.js\",\"kM9hD\",\"sr_YR.4a0d0ed6.js\",\"TIhIi\",\"sv.cd1cb449.js\",\"6Nr8y\",\"th.44777e9f.js\",\"iNazb\",\"tr.e7379a9f.js\",\"koG8I\",\"uk.4bc3f0b4.js\",\"4RuWj\",\"vi.6fd86c8f.js\",\"lEIXr\",\"zh_TW.0bb318b9.js\",\"tfhRV\",\"zh.f127db2d.js\",\"7H8jk\",\"InactivePage.e9be6fc2.js\",\"6oTyQ\",\"HistoryPage.8e3c6a14.js\",\"lCkwS\",\"HistoryPage.d050071a.js\",\"7RG0s\",\"HistoryPage.9d9fe5de.js\",\"gct5i\",\"IncidentDetailPage.aa59a897.js\",\"274zX\",\"LiveStatusPage.4aa39acc.js\"]"));

},{"6041c641a5f3323":"l4T2r","92548d1100badfdf":"cZKtR"}],"l4T2r":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"cZKtR":[function(require,module,exports,__globalThis) {
"use strict";
var stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
var bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function getBundleURLCached(id, inputError) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL(inputError);
        bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function getOrigin(url) {
    return new URL(url).origin;
}
// TODO: convert this file to ESM once HMR issues are resolved
exports.getOrigin = getOrigin;
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;

},{}]},["2dydu"], null, "parcelRequire213a")

//# sourceMappingURL=index.runtime.4b763098.js.map
